import { createSelector } from "@reduxjs/toolkit";
import { rootState } from "../../../../../redux/store";

export const selectorToolConfig = createSelector(
    (state: rootState) => state.loginUserAndTokenData,
    (state: rootState) => state.project,
    (state: rootState) => state.allPaths,
    (state: rootState) => state.hostAndUsername,
    (state: rootState) => state.userSettingsFilePath,


    (loginUserAndTokenData, project, allPaths, hostAndUsername, userSettingsFilePath) => {
        return  {
            loginUserAndTokenData,
            project,
            allPaths,
            hostAndUsername,
            userSettingsFilePath
        }
    }
);